import { Box } from "@chakra-ui/react";
import React from "react";
import { Controller } from "react-hook-form";
import Input from "src/components/base/Input/Index";
import { DefaultProps } from "../types";

const NameForm: React.FC<DefaultProps> = ({ control }) => {
  return (
    <Box w={"100%"} mt={"24px !important"}>
      <Controller
        control={control}
        name={"name"}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            isInvalid={!!error}
            placeholder={"Nome da empresa"}
          />
        )}
      />
    </Box>
  );
};

export default NameForm;
